// USA
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  dashboard: {
    analytics_title: "Patient Analytics",
    download_count_title: "The number of installations for all time by games",
    total_users: "Total users",
    total_profit: "Total profit",
    profit: "Profit",
    profit_popover: "Profit for all active games of active users",
    number_of_users: "Active users",
    price_per_game: "Price per game",
    active: "Active",
    not_active: "Not active",
    downloads: "Downloads",
    home_page: "Home page",
    edit_price: "Edit the price per game",
    enter_price: "Enter price",
    max_length: "Max length",
    cancel: "Cancel",
    save: "Save",
    total: "Total"
  },
  faq: {
    faq_page: "FAQ",
    title: "Frequently asked Questions",
    contact_us: "Write to us"
  },
  instruction: {
    instruction_page: "Instruction",
    title: "Instructions",
    contact_us: "Write to us",
    how_send: "How to send messages",
    presentation: "Presentation OKOLO"
  },
  notifications: {
    sending_messages: "Sending messages",
    specify_recipients: "Specify message recipients",
    which_game: "Which game should you send?",
    who_should: "Who should I send?",
    all_patients: "All patients",
    everyone_active_game: "Everyone with an active game",
    anyone_inactive_game: "Anyone with an inactive game",
    specify_from_list: "Specify from the list",
    use_post_template: "Use post template",
    new: "New",
    template_1: "Template 1",
    template_2: "Template 2",
    template_3: "Template 3",
    name: "Name",
    enter_name: "Enter notification title",
    max_length: "Max length",
    message: "Message",
    enter_text: "Enter notification text",
    send: "Send notification",
    save_template: "Save Template",
    last_active: "Last active",
    want_send: "Are you sure you want to send this message to patients?",
    sent: "Sent",
    sent_message: "The message was successfully sent to the selected patients",
    of_course: "Of course",
    not_sent: "Message not sent",
    list_empty:
      "The recipient list is empty. Select recipients manually, or change filter settings.",
    error: "Error",
    contact_admin: "Contact your administrator or try again later.",
    cancel: "Cancel"
  },
  login: {
    welcome: "Welcome to OKOLO",
    pass: "Password",
    forgot: "Forgot your password?",
    login: "Login",
    enter_email_for_reset: "Enter your email address to reset your password",
    reset_pass: "Reset the password",
    back: "Back",
    about_us: "About us",
    contact_us: "Connect with us",
    enter_email: "Enter Email",
    enter_password: "Enter password",
    email_not_valid: "The value is not a valid email address",
    provide_correct_data: "Please, provide correct data!"
  },
  header_menu: {
    patients_btn: "Patients",
    add_patient: "Add patient",
    email_not_valid: "The value is not a valid email address.",
    enter_password: "Enter password.",
    min_length: "Minimum length",
    max_length: "Maximum length",
    last_name: "Surname",
    first_name: "Name",
    phone_number: "Phone number",
    comment: "Comment",
    pass: "Password",
    enter_last_name: "Please enter your last name",
    enter_first_name: "Enter your name",
    enter_phone_number: "Enter your phone number",
    enter_comment: "Enter your comment",
    enter_pass: "Enter password",
    enter_email: "Enter Email",
    cancel: "Cancel",
    save: "Save",
    for_instance: "For example:",
    doctor_code: "Your doctor code : "
  },
  footer: {
    news: "News"
  },
  topbar: {
    notification_user: "User notifications"
  },
  patients: {
    patients: "Patients",
    patients_list: "List of all your patients",
    search_placeholder: "Search...",
    patient_page: "Patient page",
    active_before: "Available before: ",
    active_until: "Available until: ",
    status_th: "СТАТУС",
    access_games_th: "ACCESS TO THE GAMES",
    full_name_th: "FUll NAME",
    contacts_th: "CONTACTS",
    finance_th: "FINANCE",
    comments_th: "COMMENT",
    not_active: "Not active",
    active: "Active"
  },
  patient: {
    patient: "Patient",
    delete_patient: "Delete patient",
    edit_patient: "Edit Patient",
    min_length: "Minimum length",
    max_length: "Maximum length",
    last_name: "Last name",
    first_name: "Name",
    phone_number: "Phone number",
    comment: "Comment",
    pass: "Password",
    enter_last_name: "Enter your last name",
    enter_first_name: "Enter name",
    enter_phone_number: "Enter your phone number",
    enter_comment: "Enter your comment",
    cancel: "Cancel",
    save: "Save",
    for_instance: "For example:",
    active_user: "Active user",
    inactive_user: "Inactive user",
    total_time: "Total time",
    in_games_h: "in games (h)",
    average_time: "Average time",
    deactivate_patient: "Deactivate patient",
    activate_patient: "Activate patient",
    access: "Access",
    yes: "Yes",
    no: "No",
    game_available_until: "The game is available until: ",
    by_levels: "By levels",
    by_time: "By time",
    days: "Days",
    levels_graph_by_date: "Graph of game levels by date",
    time_m: "Time (m)",
    time: "Time",
    timeline_by_date: "Timeline of the game by dates",
    date_and_format: 'Date "mm.dd"',
    want_remove_patient: "Are you sure you want to remove the patient?",
    deleted: "Deleted",
    patient_deleted: "Patient record was successfully deleted",
    ok: "Got it",
    level_in_game: "Patient level in the game",
    playing_time: "Playing time in hours",
    level: "Level",
    create_date: "Registration date"
  },
  quick_user: {
    hello: "Hello",
    doctor: "Doctor:",
    user_profile: "User profile",
    code: "Code:",
    exit: "Exit"
  }
};
